// en_pms_live_board.ts
// Tłumaczenia dla PMS.LiveBoard.Dashboard.tsx

export const enPmsLiveBoard = {

  title:         "Live Board",
  managerView:   "Manager dashboard",
  newReservation:"New reservation",
  today:         "Today",

  // ── Kafelki główne ───────────────────────────────────────────────────────
  tiles: {
    occupancySold: "Occupancy (sold tonight)",
    inHouseNow: "In-House (occupied now)",
    readyToSell: "Ready to Sell",
    soldTonight: "Sold tonight: {{occupied}} / {{sellable}} sellable rooms",
    notAvailable: "Not available",
    ofTotal: "{{percent}}% of total",
    needsActionWithRoutine: "Needs action · {{count}} routine status",
    inHouseNowHint: "Guests in the house right now, today's departures included",
    occupancy:   "Occupancy",
    arrivals:    "Arrivals",
    departures:  "Departures",
    inHouse:     "In-house",
    readyRooms:  "Ready rooms",
    openIssues:  "Open issues",
  },

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    housekeeping: "Housekeeping",
    frontDesk:    "Front Desk",
    billing:      "Billing",
  },

  // ── Przyciski operacji ───────────────────────────────────────────────────
  actions: {
    checkIn:        "Check in",
    checkInNow:     "Check in now",
    checkOut:       "Check out",
    confirmCheckIn: "Confirm check-in",
    confirmCheckOut:"Confirm check-out",
    confirmMove:    "Confirm move",
    earlyCheckIn:   "Early check-in",
    lateCheckOut:   "Late checkout",
    roomMove:       "Room move",
    walkIn:         "Walk-in",
    approve:        "Approve",
    addNote:        "Add note",
    saveNote:       "Save note",
  },

  // ── Notatka ──────────────────────────────────────────────────────────────
  noteQuestion: "What should the team know?",

  // ── Statusy i wyniki akcji ───────────────────────────────────────────────
  messages: {
    checkInSuccessful:       "Check-in completed successfully",
    checkInFailed:           "Check-in failed",
    checkOutSuccessful:      "Check-out completed successfully",
    checkOutFailed:          "Check-out failed",
    checkInNotPossible:      "Check-in is not possible before the arrival date",
    lateCheckoutFailed:      "Late checkout failed",
    lateCheckoutUntil:       "Late checkout until ",
    roomMoveCompleted:       "Room move completed",
    roomMoveFailed:          "Room move failed",
    roomMovePrefix:          "Move: ",
    noteAdded:               "Note added",
    failedToAddNote:         "Failed to add note",
    alertDismissed:          "Alert dismissed",
    approved:                "Approved",
    approvedFromLiveBoard:   "Approved from Live Board",
    paymentPosted:           "Payment posted",
    chargePosted:            "Charge posted",
    housekeepingTaskCreated: "Housekeeping task created",
    incidentResolved:        "Incident resolved",
    reservationCreated:      "Reservation created",
    walkInCheckedIn:         "Walk-in checked in: ",
    walkInFailed:            "Walk-in failed",
    walkInReservationCreated:"Walk-in reservation created",
    roomStatusUpdated:       "Room status updated",
    failedToUpdateRoom:      "Failed to update room",
    failedToUpdateRoomStatus:"Failed to update room status",
    failedToUpdateIncident:  "Failed to update incident",
    failedToAssign:          "Failed to assign",
    noPropertySelected:      "No property selected",
    noPendingArrivals:       "No pending arrivals",
    noPendingDepartures:     "No pending departures",
    needsAction:             "Needs action",
  },

  // ── Etykiety tabelki/kart ─────────────────────────────────────────────────
  labels: {
    floor:    "Floor ",
    room:     "Room ",
    guest:    "Guest",
    guestsNow:"Guests now",
    fullName: "Full name",
    standard: "Standard",
    nights:   "Nights",
  },

} as const;

export default enPmsLiveBoard;
